import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  IconButton,
  Button as MuiButton,
  Grid,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface MarkNoShowModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  workerFullName: string;
}

const MarkNoShowModal: React.FC<MarkNoShowModalProps> = ({
  open,
  onClose,
  onConfirm,
  workerFullName,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ 'data-testid': 'markNoShowModal' } as never}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px 20px 16px 20px',
        }}
      >
        <Typography
          sx={{
            color: '#1C1C1C',
            fontFamily: 'Manrope',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '22.4px',
          }}
        >
          Resolve Timesheet
        </Typography>
        <IconButton aria-label="Close" onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: '0 20px 20px 20px' }}>
        <Typography
          sx={{
            color: '#1C1C1C',
            fontFamily: 'Manrope',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '22.4px',
            mb: 2,
          }}
        >
          Mark{' '}
          <Box component="span" sx={{ fontWeight: 700 }}>
            {workerFullName}
          </Box>{' '}
          as{' '}
          <Box component="span" sx={{ fontWeight: 700 }}>
            No-Show
          </Box>
        </Typography>
        <Typography
          sx={{
            color: '#5B5B5B',
            fontFamily: 'Manrope',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '22.4px',
            mb: 3,
          }}
        >
          Confirm this worker missed this shift. They'll be marked as a no-show,
          which may affect their dependability score.
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <MuiButton
              fullWidth
              onClick={onClose}
              variant="outlined"
              sx={{
                borderColor: '#45A735',
                color: '#45A735',
                textTransform: 'none',
                fontWeight: 600,
                height: 40,
              }}
            >
              Cancel
            </MuiButton>
          </Grid>
          <Grid item xs={6}>
            <MuiButton
              fullWidth
              variant="contained"
              onClick={onConfirm}
              sx={{
                bgcolor: '#45A735',
                '&:hover': { bgcolor: '#45A735' },
                textTransform: 'none',
                fontWeight: 600,
                height: 40,
              }}
            >
              Confirm
            </MuiButton>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default MarkNoShowModal;
